import { ObjectDirective } from 'vue';

const LongPress: ObjectDirective = {
    // 组件mounted时执行指令
    mounted(el, binding, vNode) {
        // 确保提供的表达式是函数
        if (typeof binding.value !== 'function') {
            // // 将警告传递给控制台
            const warn = `[longpress:] provided expression '${binding.value}' is not afunction, but has to be `;
            // console.log(warn);
        } else {
            const state = {
                beginX: -1,
                beginY: -1,
                nowX: -1,
                nowY: -1,
            };
            // console.table({ el, binding, vNode });
            let timer: ReturnType<typeof setTimeout> | null = null; // 定义空 定时器
            // 回调长按处理
            const handler = () => {
                // const msg_id = parseInt(el.getAttribute('msg_id'));
                // const group_id = parseInt(el.getAttribute('group_id'));
                // console.log('@@@', msg_id, '@@@', group_id);
                binding.value(el);
            };
            const start = (e: MouseEvent | TouchEvent) => {
                // console.log(e);
                // 下列事件不执行1.不是鼠标左键2.单击事件  (3.没有传入长按时间 ?? 有默认)
                // if ((<MouseEvent>e).button !== 0 && e.type === 'click') {
                if (e.type === 'click') {
                    return;
                }
                if (timer == null) {
                    // 先记录一下触摸位置
                    // 如果是touchEvent（移动端手指触摸，拿到其触摸点通过如下方式：）
                    if (e instanceof TouchEvent) {
                        state.beginX = e.touches[0].clientX;
                        state.beginY = e.touches[0].clientY;
                        state.nowX = e.touches[0].clientX;
                        state.nowY = e.touches[0].clientY;
                    } else if (e instanceof MouseEvent) {
                        // 如果是mouseevent，则通过如下方式拿到触摸点
                        state.beginX = e.clientX;
                        state.beginY = e.clientY;
                        state.nowX = e.clientX;
                        state.nowY = e.clientY;
                    }
                    timer = setTimeout(() => {
                        let dis = -1;
                        if (e instanceof TouchEvent) {
                            const disX = Math.abs(state.nowX - state.beginX);
                            const disY = Math.abs(state.nowY - state.beginY);
                            dis = Math.sqrt(disX ** 2 + disY ** 2);
                            // console.log('@@@long press move distance', dis);
                        } else if (e instanceof MouseEvent) {
                            const disX = Math.abs(e.clientX - state.beginX);
                            const disY = Math.abs(e.clientY - state.beginY);
                            dis = Math.sqrt(disX ** 2 + disY ** 2);
                            // console.log('@@@long press move distance', dis);
                        }
                        if (dis > 50) {
                            // 如果移动超过了50，就认为是在滑动，而不是长按，不执行handler
                            return;
                        }
                        handler();
                    }, 500); // 默认长按0.5秒执行绑定的函数
                }
            };
            // 监听移动，更新触摸点
            const move = (e: MouseEvent | TouchEvent) => {
                if (e instanceof TouchEvent) {
                    state.nowX = e.touches[0].clientX;
                    state.nowY = e.touches[0].clientY;
                } else if (e instanceof MouseEvent) {
                    state.nowX = e.clientX;
                    state.nowY = e.clientY;
                }
            };
            const cancel = () => {
                if (timer !== null) {
                    clearTimeout(timer);
                    // console.log('cancel console log:@@@', timer); //定时器默认返回一个随机的number 这个number的值是这个定时器的id
                    timer = null;
                }
            };

            // 添加事件监听器
            el.addEventListener('mousedown', start);
            el.addEventListener('touchstart', start);
            el.addEventListener('touchmove', move);
            // 取消计时器
            el.addEventListener('click', cancel);
            el.addEventListener('mouseout', cancel);
            el.addEventListener('touchend', cancel);
            el.addEventListener('touchcancel', cancel);
        }
    },
};

export default LongPress;
